import { Popover, Steps } from "antd";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import BillingDetails from "../components/subscribe-now/BillingDetails";
import PaymentSummary from "../components/subscribe-now/PaymentSummary";
import Confirmation from "../components/subscribe-now/Confirmation";
import { usePayment } from "../components/subscribe-now/hooks/usePayment";
import AuthenticatedLayout from "../layout/AuthenticatedLayout";
import PricingPlans from "./PricingPlans";

export const customDot = (dot, { status, index, title }) => (
  <Popover
    content={
      <span>
        {title} status: {status}
      </span>
    }
  >
    {dot}
  </Popover>
);

const StepComponent = ({ step, setStep }) => {
  const { handleBilling, purchaseSubscription, loading, billingDetails } =
    usePayment();
  const stepComponents = {
    0: <PricingPlans setStep={(val) => setStep(val)} isCheckout />,
    1: (
      <BillingDetails
        setStep={setStep}
        billingDetails={billingDetails}
        handleBilling={handleBilling}
      />
    ),
    2: (
      <PaymentSummary
        setStep={setStep}
        purchaseSubscription={purchaseSubscription}
        loading={loading}
      />
    ),
    3: <Confirmation />,
  };

  return stepComponents[step] || <></>;
};

const Checkout = () => {
  const [step, setStep] = useState(0);
  const [searchParams] = useSearchParams();
  const plan = searchParams.get("plan");
  const payment = searchParams.get("payment");

  useEffect(() => {
    if (payment === "inprogress") {
      setStep(2);
    } else if (payment === "success") {
      setStep(3);
    } else if (plan && step < 2) {
      setStep(1);
    }
  }, [plan, step, payment]);

  return (
    <AuthenticatedLayout>
      <div className="padd-90 d-flex flex-column align-items-center justify-content-center gap-20">
        <Steps
          current={step}
          progressDot={customDot}
          items={[
            {
              title: "Package",
            },
            {
              title: "Billing Detail",
            },
            {
              title: "Payment & Summary",
            },
            {
              title: "Confirmation",
            },
          ]}
        />
        <StepComponent step={step} setStep={(val) => setStep(val)} />
      </div>
    </AuthenticatedLayout>
  );
};

export default Checkout;
